import { render, staticRenderFns } from "./msgCode.vue?vue&type=template&id=7653808a&"
import script from "./msgCode.vue?vue&type=script&lang=js&"
export * from "./msgCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports